import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useHeader from '../../hooks/useHeader'

import styles from '../../styles/components/Header/HeaderLink.module.css'

const HeaderLink = props => {
  const header = useHeader()
  const className = classnames(styles.link, {
    [styles.linkActive]: props.isActive,
    [styles.linkFixed]: props.isFixed
  })

  const onClick = event => {
    const section = document.getElementById(props.id)

    header.onToggleClick()

    if (section) {
      event.preventDefault()
      section.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    }
  }

  return (
    <a onClick={onClick} href={`#${props.id}`} className={className}>
      {props.children}
    </a>
  )
}

HeaderLink.propTypes = {
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isFixed: PropTypes.bool.isRequired,
  children: PropTypes.string.isRequired
}

export { HeaderLink }
